import { render, staticRenderFns } from "./IconDropdown.vue?vue&type=template&id=d6363886&"
import script from "./IconDropdown.vue?vue&type=script&lang=js&"
export * from "./IconDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports